module.exports = __webpack_public_path__ + "static/media/md-phone-portrait.cc252650.svg";